class Websocket {
  constructor() {
    if (Websocket._websocketInstance) return Websocket._websocketInstance;
    Websocket._websocketInstance = this;
    
    this._websocket = null;
    this._websocketIsConnected = false;
    this._websocketReconnectionAttempts = 0;
    this._websocketReconnectionMaxAttempts = 5;
    this._websocketReconnectionDelay = 1000; 
    this._websocketMessageListeners = new Map();
  }

  connectWebsocket() {
    if (this._websocket && this._websocketIsConnected) return;
    this._websocket = new WebSocket(process.env.VUE_APP_BACKEND_WEBSOCKET_URL);
    this._websocket.addEventListener('open', () => {
      this._websocketIsConnected = true;
      this._websocketReconnectionAttempts = 0;
      const websocketMessageData = 
      {
        'websocketMessageID': 'startConnection',
        'localStorage': 
        {
          'CRMAccountID': localStorage.getItem('CRMAccountID'),
          'CRMAgentID': localStorage.getItem('CRMAgentID')
        }
      }; 
      
      // Función para intentar enviar el mensaje inicial
      const trySendInitialMessage = () => {
        if (this._websocket && this._websocket.readyState == WebSocket.OPEN) {
          this.sendWebsocketMessage(websocketMessageData);
        } else {
          setTimeout(trySendInitialMessage, 100);
        }
      };
      
      trySendInitialMessage();
    });

    this._websocket.addEventListener('close', () => {
      this._websocketIsConnected = false;
      this.handleWebsocketReconnect();
    });

    this._websocket.addEventListener('error', () => {
      this._websocketIsConnected = false;
      // mostrar notification dialog
    });

    this._websocket.addEventListener('message', (event) => {
      try {
        const websocketMessageData = JSON.parse(event.data);
        this.handleIncomingWebsocketMessage(websocketMessageData);
      } catch {
        console.log('Error al procesar mensaje');
        // mostrar notification dialog
      }
    });
  }

  handleWebsocketReconnect() {
    if (this._websocketReconnectionAttempts < this._websocketReconnectionMaxAttempts) {
      this._websocketReconnectionAttempts++;
      setTimeout(() => this.connectWebsocket(), this._websocketReconnectionDelay * this._websocketReconnectionAttempts);
    } else {
      console.error('Máximo número de intentos de reconexión alcanzado');
      // mostrar notification dialog
    }
  }

  handleIncomingWebsocketMessage(websocketMessageData) {
    if (this._websocketMessageListeners.has(websocketMessageData.websocketMessageID)) {
      this._websocketMessageListeners.get(websocketMessageData.websocketMessageID).forEach(callback => {
        callback(websocketMessageData);
      });
    }
  }

  sendWebsocketMessage(websocketMessageData) {
    if (this._websocket && this._websocket.readyState == WebSocket.OPEN) {
      this._websocket.send(JSON.stringify(websocketMessageData));
    } else {
      console.warn('No se puede enviar mensaje: WebSocket no conectado o no está listo');
      // mostrar notification dialog
    }
  }

  addWebsocketMessageListener(websocketMessageID, callbackFunction) {
    if (!this._websocketMessageListeners.has(websocketMessageID)) {
      this._websocketMessageListeners.set(websocketMessageID, new Set());
    }
    this._websocketMessageListeners.get(websocketMessageID).add(callbackFunction);
  }

  removeWebsocketMessageListener(websocketMessageID, callbackFunction) {
    if (this._websocketMessageListeners.has(websocketMessageID)) {
      this._websocketMessageListeners.get(websocketMessageID).delete(callbackFunction);
    }
  }

  disconnectWebsocket() {
    if (this._websocket) {
      this._websocket.close();
      this._websocket = null;
      this._websocketIsConnected = false;
    }
  }
}

export default new Websocket(); 